<template>
    <div class="">
        <div class="relative select-none">
            </div>                            <!-- options select -->
                        <div class="" v-for="option in options" :key="option.id">
                                <div class="flex items-center justify-between mr-4">
                                    <label :class="light ? 'text-gray-200' : 'text-gray-800'" class="m-1 block font-medium text-gray-600">{{option.label}}</label>
                                    <input :id="option.id" name="notification-method" @click="setSelectedOption(option)" :checked="selectedOption == option.id" type="radio" class=" w-6 h-6 text-blue-600 focus:ring-blue-500 border-gray-300 cursor-pointer">
                                </div>                          
            </div>
    
        </div>
    
    </template>
    
    <script>
    
    export default {
        name: 'CustomCheckboxButton',

        components: {
    
        },
        props: {
            label: String,
            options: Array,
            modelValue: {
                type: Array,
                default: () => []
            },
        },
        data() {
            return {
                showCheckbox: false,
                selectedOption: undefined,
            }
        },
        methods: {
            handleClickAway() {
                this.showCheckbox = false;
            },
            setSelectedOption(option) {
                this.selectedOption = option
                this.$emit('update:modelValue', this.selectedOption);

            }
        },
        watch: {
            modelValue: {
                deep: true,
                handler() {
                }
            },
            options: {
                deep: true,
                handler() {
                }
            }
            
            
            
            
            
            
            
        },
        created() {
            this.selectedOption = this.modelValue.id
            
        }
    
    }
    </script>